module.exports = __webpack_public_path__ + "static/media/sterling-and-wilson.3d1cd479.png";